import ApiProvider from 'src/core/ApiProvider';

export default {
  orderList: ({ start = 0, limit = 10, order = 'desc', day = null }: { start: number; limit: number; order: 'desc' | 'asc'; day: null | number }) => {
    return ApiProvider({
      start,
      limit,
      order,
      day,
      methodName: 'Module/Orders/Web/OrderList',
    });
  },
  userCancelAndRefundList: ({ start = 0, limit = 10, order = 'desc', day = null }: { start: number; limit: number; order: 'desc' | 'asc'; day: null | number }) => {
    return ApiProvider({
      start,
      limit,
      order,
      day,
      methodName: 'Module/Orders/Web/UserCancelAndRefundList',
    });
  },
  shippingDetail: (orderId: number) => {
    return ApiProvider({
      orderId,
      methodName: 'Module/Orders/Web/OrderShippingDetailWeb',
    });
  },
  changeAddress: ({ orderId, addressId }: { orderId: number; addressId: number }) => {
    return ApiProvider({
      orderId,
      addressId,
      methodName: 'Module/Orders/Web/ChangeAddress',
    });
  },
  changeBillingAddress: ({ orderId, addressId }: { orderId: number; addressId: number }) => {
    return ApiProvider({
      orderId,
      addressId,
      methodName: 'Module/Orders/Web/ChangeBillingAddress',
    });
  },
  requestOrderRefund: ({ orderId, text, variationCodes, note }: { orderId: number; text: string; variationCodes: number[]; note: string }) => {
    return ApiProvider({
      orderId,
      text,
      variationCodes,
      note,
      methodName: 'Module/Orders/Web/RequestOrderRefund',
    });
  },
  requestOrderCancellation: ({ orderId, text, note }: { orderId: number; text: string; note: string }) => {
    return ApiProvider({
      orderId,
      text,
      note,
      methodName: 'Module/Orders/Web/RequestOrderCancellation',
    });
  },
  orderCaseList: () => {
    return ApiProvider({
      methodName: 'Module/Orders/Web/OrderCaseList',
    });
  },
  checkAndCreateOrder: ({ addressId, billingAddressId }) => {
    return ApiProvider({
      addressId,
      billingAddressId,
      methodName: 'Module/Orders/Web/CheckAndCreateOrder',
    });
  },
  orderPaymentCompletionDetail: ({ orderId }) => {
    return ApiProvider({
      orderId,
      methodName: 'Module/Orders/Web/OrderPaymentCompletionDetail',
    });
  },
  makePayment: ({ orderId, paymentMethod }) => {
    return ApiProvider({
      orderId,
      paymentMethod,
      methodName: 'Module/Orders/Web/MakePayment',
    });
  },
  completeOrder: ({ secret, orderId, paymentMethod, paymentInfo }) => {
    return ApiProvider({
      secret,
      orderId,
      paymentMethod,
      paymentInfo,
      methodName: 'Module/Orders/Web/CompleteOrder',
    });
  },
  orderDetailForShopier: ({ secret, orderId }) => {
    return ApiProvider({
      secret,
      orderId,
      methodName: 'Module/Orders/Web/OrderDetailForShopier',
    });
  },
};
